var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamDiversity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    enableBackground: "new 0 0 18 18",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#535B66",
    clipRule: "evenodd",
    d: "M9.28,0c2.906,0,5.812,0,8.717,0c0,2.907,0,5.813,0,8.719 c-0.841,0-1.682,0-2.53,0c0.477-1.526-0.667-2.573-1.648-2.636c-0.573-0.037-1.081,0.121-1.496,0.52 c-0.613,0.589-0.746,1.305-0.501,2.1c-0.855,0-1.689,0-2.538,0c0-0.076,0-0.14,0-0.203c0-0.896,0-1.792,0-2.688 c0-0.053,0.002-0.105-0.002-0.158c-0.02-0.228-0.234-0.342-0.435-0.231C8.792,5.453,8.741,5.493,8.686,5.525 C8.2,5.807,7.588,5.761,7.155,5.411c-0.436-0.353-0.61-0.94-0.438-1.473C6.996,3.073,8,2.736,8.778,3.248 C8.886,3.319,9.006,3.39,9.115,3.302c0.08-0.065,0.162-0.185,0.163-0.28C9.288,2.014,9.282,1.007,9.28,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#535B66",
    clipRule: "evenodd",
    d: "M0,8.719C0,5.812,0,2.906,0,0c2.906,0,5.812,0,8.717,0c0,0.841,0,1.683,0,2.531 C7.157,2.029,6.127,3.256,6.08,4.194c-0.029,0.58,0.133,1.092,0.543,1.504C7.21,6.29,7.919,6.418,8.701,6.174 c0,0.856,0,1.69,0,2.538c-0.077,0-0.14,0-0.203,0c-0.896,0-1.792,0-2.688,0c-0.059,0-0.118-0.002-0.175,0.004 c-0.208,0.027-0.315,0.233-0.22,0.42C5.44,9.188,5.479,9.234,5.508,9.285c0.28,0.492,0.285,0.988-0.03,1.459 c-0.306,0.458-0.752,0.667-1.3,0.589c-0.574-0.082-0.957-0.418-1.123-0.977C2.933,9.944,3.016,9.561,3.257,9.205 c0.167-0.248,0.052-0.489-0.236-0.491C2.014,8.712,1.007,8.717,0,8.719z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#535B66",
    clipRule: "evenodd",
    d: "M17.997,9.281c0,2.907,0,5.813,0,8.719c-2.906,0-5.811,0-8.717,0 c0-0.84,0-1.681,0-2.535c0.943,0.267,1.731,0.074,2.296-0.716c0.456-0.635,0.499-1.347,0.111-2.022 c-0.535-0.933-1.373-1.185-2.39-0.909c0-0.846,0-1.68,0-2.53c0.076,0,0.139,0,0.203,0c0.896,0,1.792,0,2.688,0 c0.059,0,0.118,0.003,0.175-0.004c0.209-0.026,0.318-0.23,0.223-0.417c-0.026-0.052-0.065-0.097-0.094-0.147 c-0.283-0.491-0.29-0.988,0.026-1.458c0.31-0.461,0.76-0.67,1.316-0.588c0.57,0.083,0.942,0.42,1.107,0.969 c0.125,0.419,0.035,0.807-0.207,1.168c-0.16,0.237-0.039,0.475,0.241,0.476C15.983,9.288,16.99,9.283,17.997,9.281z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#535B66",
    clipRule: "evenodd",
    d: "M8.717,18C5.814,18,2.912,18,0,18c0-2.906,0-5.813,0-8.719 c0.841,0,1.681,0,2.535,0c-0.268,0.955-0.07,1.748,0.734,2.308c0.652,0.456,1.374,0.486,2.054,0.073 c0.892-0.543,1.128-1.367,0.857-2.364c0.845,0,1.679,0,2.533,0c0,0.074,0,0.137,0,0.2c0,0.762-0.001,1.523,0,2.285 c0,0.182-0.005,0.364,0.002,0.545c0.01,0.258,0.241,0.376,0.461,0.241c0.035-0.021,0.066-0.048,0.102-0.069 c0.573-0.361,1.33-0.237,1.761,0.287c0.429,0.521,0.411,1.273-0.043,1.77c-0.459,0.503-1.184,0.585-1.772,0.199 C9.109,14.68,8.985,14.61,8.87,14.707c-0.075,0.062-0.149,0.177-0.151,0.27C8.709,15.984,8.715,16.992,8.717,18z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamDiversity);
export default __webpack_public_path__ + "static/media/TeamDiversity.13eaee195579b1323c2465edc5340f48.svg";
export { ForwardRef as ReactComponent };